import React, { useCallback } from 'react';
import FileDownloadOutlineIcon from 'mdi-react/FileDownloadOutlineIcon';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { dashboardActions, useDashboard } from '@crm-framework/dashboard';
import { IconButton } from '@crm-framework/icon-button';
import { checkRights } from '@crm-framework/auth';

import { ICoreState } from '@crm-package/app';
import { USER_RIGHTS } from '@crm-package/auth';

const checkExportRights = createSelector(
  (state: ICoreState) =>
    checkRights(state, [USER_RIGHTS.EXPORT, USER_RIGHTS.EXCEL_VIEW_EMAIL]),
  (canExportWithEmail) => ({
    canExportWithEmail,
  })
);

export const ExportWithEmailButton: React.VFC<{ dashboardName }> = ({
  dashboardName,
}) => {
  const dispatch = useDispatch();
  const { canExportWithEmail } = useSelector(checkExportRights);
  const { isLoading, isAlreadySearched } = useDashboard(dashboardName);

  const onDownloadExcelWithEmails = useCallback(() => {
    dispatch(dashboardActions.excelExport(dashboardName, { withEmail: true }));
  }, []);

  if (!isAlreadySearched || !canExportWithEmail) return <></>;

  return (
    <IconButton
      icon={FileDownloadOutlineIcon}
      withHover
      appearance="primary"
      title="Export with email"
      disabled={isLoading}
      onClick={onDownloadExcelWithEmails}
    />
  );
};
